import { PodcastStatusEnum, type PodcastStatusValue } from '../types/enums'

export type NormalizedStatus = 'Draft' | 'Processing' | 'Completed' | 'Failed' | 'Unknown'

export function normalizeStatus(value: PodcastStatusValue): NormalizedStatus {
  switch (value) {
    case PodcastStatusEnum.Draft: 
      return 'Draft'
    case PodcastStatusEnum.Processing: 
      return 'Processing'
    case PodcastStatusEnum.Completed: 
      return 'Completed'
    case PodcastStatusEnum.Failed: 
      return 'Failed'
    default: 
      return 'Unknown'
  }
}
